var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIxigua(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 179 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.673,178.685C138.85,178.676 178.709,138.802 178.7,89.625C178.691,40.447 138.818,0.588 89.64,0.597C40.463,0.606 0.604,40.48 0.613,89.657C0.617,111.896 14.182,114.181 22.885,115.646C24.75,115.96 26.393,116.237 27.63,116.664C44.219,123.397 55.895,134.312 61.46,150.482C62.346,152.418 62.843,154.868 63.379,157.512C65.277,166.881 67.669,178.685 89.673,178.685ZM73.553,122.786C86.125,128.36 128.421,106.333 128.42,90C128.42,74.156 86.816,50.732 72.947,57.517C60.346,62.415 60.428,117.441 72.297,122.272C72.429,122.325 73.265,122.658 73.553,122.786Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxigua);
export default __webpack_public_path__ + "static/media/Ixigua.a63856d0.svg";
export { ForwardRef as ReactComponent };